import DatePicker from 'components/date-picker/DatePicker';
import { colors } from 'constants/theme';
import accountStyles from './account-option.style';
import { useEffect, useState } from 'react';
import moment from 'moment';
import userApi from 'apis/userApi';
import { InfoPaginate } from 'models/commonModel';
import Pagination from 'components/pagination/Pagination';
import LoadingIcon from 'components/loading/LoadingIcon';
import toast from 'react-hot-toast';
import classNames from 'classnames';
import { HistoryBetPayload } from 'models/fundTransferModel';
import Modal from 'components/modal/Modal';
import BetRecord from 'components/bet-record/BetRecord';
import { scrollToTopPage } from 'utils/function';
import lotteryApi from 'apis/lotteryApi';
import { css } from '@emotion/css';

interface StatusItem {
    description: string;
    disabled: boolean;
    escape: boolean;
    label: string;
    noSelectionOption: boolean;
    value: string;
}

function FundBet() {
    const [startTime, setStartTime] = useState<Date | null>(new Date(`${moment(new Date()).format('yyyy-MM-DD')} 00:00:00`));
    const [endTime, setEndTime] = useState<Date | null>(new Date(`${moment(new Date()).format('yyyy-MM-DD')} 23:59:59`));

    const [statusList, setStatusList] = useState<StatusItem[]>([]);
    const [statusSelect, setStatusSelect] = useState('');

    const [timeSelect] = useState('0');

    const [gameList, setGameList] = useState<StatusItem[]>([]);
    const [gameValueSelect, setGameValueSelect] = useState('-1');
    const [infoPage, setInfoPage] = useState<InfoPaginate | null>(null);
    const [recordList, setRecordList] = useState<any[] | null>(null);

    const [betId, setBetId] = useState('');
    const [loading, setLoading] = useState(false);

    const [totalBetWin, setTotalBetWin] = useState<{ tbet: number; twin: number }>({ tbet: 0, twin: 0 });
    const [betRecordId, setBetRecordId] = useState<string | null>(null);

    useEffect(() => {
        const getStatusList = async () => {
            try {
                const { data } = await userApi.gameRecordInit({});
                if (!data.msg) {
                    //remove 5:huy nuôi số, 9:nổ hũ
                    const statusData: any[] = data.statuslist.filter((item: StatusItem) => ![5, 9].includes(Number(item.value)));
                    setStatusList(statusData);

                    //remove 300:txcb, 301:tren duoi, 303:cao rua v1, 22:livestream 2p, tai xiu, xoc dia, bau cua
                    const gameData = data.lotterylist.filter((item: StatusItem) => ![300, 301, 303, 22, 90, 91, 92, 93, 80, 60].includes(Number(item.value)));
                    setGameList(gameData);
                    if (statusData.length > 0) {
                        setStatusSelect(statusData[0].value);
                    }
                }
            } catch (error) {
                console.log(error);
            }
        };
        getStatusList();
    }, []);

    const handleChangePage = (page: number) => {
        searchRecordBet(page, false, 'inputPage');
        scrollToTopPage();
    };

    const searchRecordBet = async (page: number, isResetPaginate: boolean, type: 'mobileSearch' | 'inputPage') => {
        if (isResetPaginate) {
            setInfoPage(null);
        }
        setLoading(true);
        let payload: HistoryBetPayload = {
            status: statusSelect,
            betid: betId,
            starttime: startTime ? moment(startTime).format('yyyy-MM-DD HH:mm:ss') : '',
            endtime: endTime ? moment(endTime).format('yyyy-MM-DD HH:mm:ss') : '',
            lotteryid: Number(gameValueSelect),
            pagesize: 10,
            type: timeSelect,
        };

        if (type === 'inputPage') {
            payload = {
                ...payload,
                curpage: infoPage?.curpage,
                num: page,
            };
        }
        try {
            const { data } = await userApi.gameRecordSearch(payload, type);
            if (!data.msg) {
                setRecordList(data.reslist);
                const { curpage, totalpage, totalrecord } = data;
                setInfoPage({ curpage, totalpage, totalrecord });

                setTotalBetWin({ tbet: data.tamount, twin: data.twin });
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const handleCancelBet = async (recordId: string) => {
        setLoading(true);
        try {
            const { data } = await lotteryApi.lotteryCancelBet({ id: recordId });
            if (!data.msg) {
                toast.success('Huỷ cược thành công');
                setBetRecordId(null);
                searchRecordBet(infoPage ? infoPage.curpage : 1, false, 'mobileSearch');
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className={`${styles.wrap}`}>
                <div className={styles.containerBox}>
                    <div className={styles.itemBox}>
                        <div className={accountStyles.groupInput}>
                            <label htmlFor="">Thời Gian Từ</label>
                            <div className={styles.wrapInput}>
                                <DatePicker maxDate={new Date()} showTime dateSelect={startTime} onSelectDate={(date) => setStartTime(date)} noneStyle />
                            </div>
                        </div>

                        <div className={accountStyles.groupInput}>
                            <label htmlFor="">Loại Xổ Số</label>
                            <div className={styles.wrapInput}>
                                <select value={gameValueSelect} onChange={(e) => setGameValueSelect(e.target.value)}>
                                    {gameList.map((item) => (
                                        <option value={item.value} key={item.value}>
                                            {item.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className={styles.itemBox}>
                        <div className={styles.groupInput}>
                            <label className={styles.none}>{'___'}</label>
                            <div className={styles.groupInputTo}>
                                <div className="centerView">
                                    <label htmlFor="">Đến</label>
                                </div>
                                <div className={styles.wrapInput}>
                                    <DatePicker maxDate={new Date()} showTime dateSelect={endTime} onSelectDate={(date) => setEndTime(date)} noneStyle />
                                </div>
                            </div>
                        </div>

                        <div className={accountStyles.groupInput} style={{ marginLeft: 40 }}>
                            <label htmlFor="">Mã Số Cược</label>
                            <div className={styles.wrapInput}>
                                <input value={betId} onChange={(e) => setBetId(e.target.value)} type="text" placeholder="Mã số cược" />
                            </div>
                        </div>
                    </div>

                    <div className={styles.itemBox} style={{ marginLeft: 40 }}>
                        <div className={accountStyles.groupInput}>
                            <label htmlFor="">Trạng Thái</label>
                            <div className={styles.wrapInput}>
                                <select value={statusSelect} onChange={(e) => setStatusSelect(e.target.value)}>
                                    {statusList.map((item) => (
                                        <option value={item.value} key={item.value}>
                                            {item.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <button type="submit" className={styles.btnSubmit} onClick={() => searchRecordBet(1, true, 'mobileSearch')}>
                            Tìm Kiếm
                        </button>
                    </div>
                </div>

                <div className={styles.containerTable}>
                    <div className={styles.table}>
                        <div className="row">
                            <div className="title col">Hội viên</div>
                            <div className="title col">Tên Xổ Số</div>
                            <div className="title col">Kiểu cược</div>
                            <div className="title col">Thời gian</div>
                            <div className="title col">Lượt xổ</div>
                            <div className="title col">Cược</div>
                            <div className="title col">Trúng</div>
                            <div className="title col">Trạng thái</div>
                            <div className="title col">Xem</div>
                        </div>
                        {recordList?.length ? (
                            recordList.map((item) => (
                                <div className="row" key={item.id}>
                                    <p className="col">{item.loginname}</p>
                                    <p className="col">{item.lotteryname}</p>
                                    <p className="col">{![60, 80, 90, 91, 92, 93, 300, 301].includes(item.lotteryid) ? item.methodname : '-'}</p>
                                    <p className="col">{moment(item.bettime).format('DD/MM/yyyy HH:mm')}</p>
                                    <p className="col">{item.issue}</p>
                                    <p className="col">{new Intl.NumberFormat().format(item.amount)}</p>
                                    <p className="col text-success">{new Intl.NumberFormat().format(item.bonus)}</p>
                                    <p className={classNames('col', { 'text-success': item.status === 4 }, { 'text-error': [1, 3, 6].includes(item.status) })}>{item.statusname}</p>
                                    <p className="col">
                                        <span className="btn-detail" style={{ padding: '4px 0', width: '100%', display: 'block' }} onClick={() => setBetRecordId(item.id)}>
                                            Xem
                                        </span>
                                    </p>
                                </div>
                            ))
                        ) : (
                            <div className="no-data" />
                        )}
                    </div>
                    {infoPage && infoPage.totalpage > 1 && (
                        <div className="pagination-common">
                            <div className="total">
                                {totalBetWin.tbet > 0 && (
                                    <>
                                        <p>
                                            Cược: <span className="text-white">{new Intl.NumberFormat().format(totalBetWin.tbet)}</span>
                                        </p>
                                        <p className="line">|</p>
                                        <p>
                                            Thắng: <span className="text-success">{new Intl.NumberFormat().format(totalBetWin.twin)}</span>
                                        </p>
                                    </>
                                )}
                            </div>
                            <Pagination infoPage={infoPage} onChangePage={handleChangePage} showTotal />
                        </div>
                    )}
                </div>
            </div>
            <Modal isShow={Boolean(betRecordId)} onClose={() => setBetRecordId(null)} closeClickBackdrop width="60%" maxWidth="900px">
                <BetRecord onClose={() => setBetRecordId(null)} betRecordId={betRecordId} onCancelBet={handleCancelBet} />
            </Modal>
            {loading && <LoadingIcon />}
        </>
    );
}

export default FundBet;

const styles = {
    wrap: css`
        color: black;
        padding: 20px;
        background-color: white;
        border-radius: 8px;
    `,
    btnSubmit: css`
        background: #ffad33 !important;
        border-radius: 3px !important;
        border: 1px solid #c9820a !important;
        color: white;
        padding-top: 10px;
        padding-bottom: 10px;
        width: 130px;
        margin-bottom: 20px;
    `,
    wrapInput: css`
        color: black;
        display: flex;
        flex: 1;
        input {
            border: none;
            height: 40px;
            border-bottom: 1px solid black;
            padding-left: 10px;
            background-color: white;
            width: 100%;
        }
        select {
            border: none;
            background-color: white;
            height: 40px;
            border-bottom: 1px solid black;
            width: 100%;
            color: black;
            box-shadow: none;
            outline: none;
            padding-left: 5px;
            &:focus {
                border: none;
                box-shadow: none;
            }
        }
    `,
    containerTable: css`
        background-color: #f2f2f2;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
        min-height: 250px;
        border-radius: 5px;
        padding: 4px 4px 18px;
        margin-bottom: 100px;
    `,
    itemBox: css`
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        label {
            font-weight: 300;
            font-size: 17px;
            width: 100%;
        }
    `,
    groupInputTo: css`
        position: relative;
        display: flex;
        align-items: flex-end;
        margin-bottom: 4px;
        width: 100%;
        .centerView {
            width: 40px;
            text-align: center;
        }
    `,
    none: css`
        color: transparent;
    `,
    groupInput: css`
        padding-bottom: 20px;
        position: relative;
        label {
            display: block;
            margin-bottom: 4px;
            padding-left: 2px;
        }
        input {
            width: 100%;
        }
    `,
    table: css`
        border-radius: 5px;
        overflow: hidden;
        &.table-col-center {
            .col {
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
        .row {
            display: flex;
            border-bottom: 1px solid var(--border-table);
            background-color: #e2dfdc;
            &:first-child {
                border-bottom-color: white;
            }
            &:last-child {
                border-bottom: none;
            }
        }
        .col {
            flex: 1;
            padding: 12px 8px;
            text-align: center;
            font-size: 12.8px;
            font-weight: 300;
        }
        .text-left {
            text-align: left;
        }
        .title {
            color: white;
            font-weight: 300;
            border-right: 1px solid white;
            background-color: ${colors.primary};
            &:last-child {
                border-right: 0;
            }
        }
        .no-data {
            text-align: center;
            padding: 30px;
            height: 180px;
            p {
                margin-top: 8px;
                font-size: 14px;
            }
        }
    `,
    containerBox: css`
        background-color: #f9f9f9;
        padding: 15px 40px 8px;
        border-radius: 3px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
        margin-bottom: 15px;
        border-left: 3px solid #ebc85e;
        display: flex;
        justify-content: space-between;
    `,
};
